/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withTranslation } from 'language/i18n';
import maskAmount from 'utils/maskAmount';

const AuctionHistory = ({
  t, offers, machine, auctionHistoryRef,
}) => {
  return (
    <>
      <div className="row mb-4">
        <div className="col">
          <h2 className="fs-17 fw-900">{t('offerHistory')}</h2>
        </div>
      </div>

      <div className="auction-history-container">
        <div className="auction-history-title">
          <span className="offer-title">{t('offer')}</span>
          <span className="">{t('date')}</span>
        </div>

        <div className="history-container" ref={auctionHistoryRef}>
          {
            offers.length > 0
              ? _.map(offers, (offer, index) => (
                <div
                  className="history"
                  style={{ backgroundColor: index % 2 === 0 ? '#eeeeee' : 'white' }}
                  key={index}
                >
                  <span className={`user-side ${index === 0 && 'fw-900'}`}>{offer.userId.substring(0, 10)}</span>
                  <span className={`ml-4 text-left flex-fill ${index === 0 && 'fw-900'}`}>{maskAmount(offer.offer)}</span>
                  <span className={`text-right ${index === 0 && 'fw-900'}`}>{`${moment(offer.createdAt).format('DD/MM/YYYY HH:mm')}${index === 0 ? '*' : ''}`}</span>
                </div>
              ))
              : (
                <div
                  className="history"
                  style={{ backgroundColor: '#eeeeee' }}
                >
                  <span className="fw-900">1</span>
                  <span className="ml-4 text-left flex-fill fw-900">{`${maskAmount(machine.auctionStartPrice)} (Başlangıç Fiyatı)`}</span>
                  <span className="text-right fw-900">{`${moment(machine.event.startDate).format('DD/MM/YYYY HH:mm')}*`}</span>
                </div>
              )
          }
        </div>
      </div>

      <div className="fs-11 text-gray3 mt-2 mb-4">
        * En yüksek teklif
        {' '}
        <b>koyu</b>
        {' '}
        renk ile işaretlenmiştir
      </div>
    </>
  );
};

AuctionHistory.propTypes = {
  t: PropTypes.func,
  offers: PropTypes.array,
  auctionHistoryRef: PropTypes.object,
  machine: PropTypes.object,
};

export default withTranslation('common')(AuctionHistory);
